module.exports = __webpack_public_path__ + "img/imagem5.b66f3a76.svg";